export enum TextResourceKey {
  PromptLabelHeader = 'platform.native.api.camera.promptLabelHeader',
  PromptLabelCancel = 'platform.native.api.camera.promptLabelCancel',
  PromptLabelPhoto = 'platform.native.api.camera.promptLabelPhoto',
  PromptLabelPicture = 'platform.native.api.camera.promptLabelPicture'
}
